import React from 'react';
import { useLocation } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  crumb: {
    textTransform: 'capitalize',
  },
}));

export const BreadCrumb = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const crumbs = pathname.slice(1).split('/');
  const format = (crumb: string) => {
    return crumb
      .replace('asct', 'ASCT')
      .replace('nec', 'NEC')
      .replace('etgv-paca', 'ETGV PACA')
      .replace('pmr', 'Assistance PMR')
      .replace('surete', 'sureté')
      .replace('securite', 'sécurité')
      .replace('-', ' ');
  };
  return (
    <Typography color="textPrimary">
      {crumbs.map((crumb, index) => (
        <React.Fragment key={crumb}>
          {index < crumbs.length - 1 ? (
            <Link className={classes.crumb}>{format(crumb)}</Link>
          ) : (
            <span className={classes.crumb}>{format(crumb)}</span>
          )}

          {index < crumbs.length - 1 ? '  >  ' : ''}
        </React.Fragment>
      ))}
    </Typography>
  );
};

export default BreadCrumb;
